<template>
  <div class="demo-input-suffix">
    <div v-show="bshowmain" style="margin-top: 5px">
      <el-input
        placeholder="请输入内容，将输出书名(或作者、版别)中包含输入内容的结果"
        v-model.trim="searchcontent.searchtext"
        class="input-with-select"
        @keyup.enter.native="searchdataout()"
      >
        <!-- <el-select v-model.trim="selectkind" slot="prepend" placeholder="请选择" @change="onselectchange">
          <el-option label="全部" value="1"></el-option>
          <el-option label="书名" value="2"></el-option>
          <el-option label="ISBN" value="3"></el-option>
          <el-option label="作者" value="4"></el-option>
          <el-option label="出版社" value="5"></el-option>
          <el-option label="出版年月" value="6"></el-option>
          <el-option label="关键词" value="7"></el-option>
        </el-select> -->
        <el-button slot="append" icon="el-icon-search" @click="searchdataout()"
          >搜索</el-button
        >
        <el-button slot="append" icon="el-icon-search" @click="advsearchop()"
          >高级搜索</el-button
        >
      </el-input>
    </div>
    <div v-show="bshowdetail">
      <el-row style="margin-top: 5px">
        <el-col :span="2">
          <div class="mylable">书名</div>
        </el-col>
        <el-col :span="10">
          <el-input v-model.trim="searchcontent.searchskuname"> </el-input>
        </el-col>
        <el-col :span="2">
          <div class="mylable">书号</div>
        </el-col>
        <el-col :span="10">
          <el-input v-model.trim="searchcontent.searchskuisbn"> </el-input>
        </el-col>
      </el-row>
      <el-row style="margin-top: 15px">
        <el-col :span="2">
          <div class="mylable">作者</div>
        </el-col>
        <el-col :span="10">
          <el-input v-model.trim="searchcontent.searchskuauthor"> </el-input>
        </el-col>
        <el-col :span="2">
          <div class="mylable">出版社</div>
        </el-col>
        <el-col :span="10">
          <el-input v-model.trim="searchcontent.searchskupublisher"> </el-input>
        </el-col>
      </el-row>
      <el-row style="margin-top: 15px">
        <!-- <el-col :span="2">
          <div class="mylable" >关键词</div>
        </el-col>
        <el-col :span="10">
          <el-input v-model.trim="searchcontent.searchskukeyword"> </el-input>
        </el-col> -->
        <el-col :span="2">
          <div class="mylable">出版日期</div>
        </el-col>
        <el-col :span="3">
          <el-date-picker
            style="width: 230px"
            v-model.trim="searchcontent.searchskupubdatebegin"
            type="date"
            value-format="yyyyMMdd"
            placeholder="请选择日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="3">
          <el-date-picker
            style="width: 230px"
            v-model.trim="searchcontent.searchskupubdateend"
            type="date"
            value-format="yyyyMMdd"
            placeholder="请选择日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="2">
          <!-- <div class="mylable">排序依据</div> -->
        </el-col>
        <el-col :span="2">
          <!-- <el-select
            ref="orderbyselect"
            v-model.trim="value"
            placeholder="请选择排序字段"
            style="width: 150px"
            @change="SelectCurrentValue"
            value-key="value"
        >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
         </el-col>
        <el-col :span="12">
       </el-col>
      </el-row>
      <el-row> </el-row>

      <!-- <el-row>
  <el-col :span="12">
    <div style="text-align: left;">
  <el-radio v-model.trim="radio" label="1">本科（缺规则）</el-radio>
  <el-radio v-model.trim="radio" label="2">大专（缺规则）</el-radio>
  <el-radio v-model.trim="radio" label="3">中小学（缺规则）</el-radio>
      </div>
  </el-col>
  <el-col :span="12">
      <div style="text-align: left;">
<el-checkbox v-model.trim="checked1">规则1</el-checkbox>
<el-checkbox v-model.trim="checked2">规则2</el-checkbox>
<el-checkbox v-model.trim="checked3">规则3</el-checkbox>
     </div>
  </el-col>
</el-row> -->

      <el-row style="margin-top: 20px; margin-bottom: 30px">
        <el-col :span="24"> </el-col>
        <div>
          <el-button-group>
            <el-button @click="searchdataout()">搜索</el-button>
            <!-- <el-button>重置</el-button> -->
            <el-button @click="advsearchop()">返回</el-button>
          </el-button-group>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import global from "../global.vue";

export default {
  data() {
    return {
      bshowmain: true,
      bshowdetail: false,
      searchcontent: {
        selectkind: "1",
        searchtext: "",
        searchskuname: "",
        searchskuisbn: "",
        searchskuauthor: "",
        searchskupublisher: "",
        searchskupubdatebegin: "",
        searchskupubdateend: "",
        searchskukeyword: "",
        sorderby: "",
      },

      options: [
        {
          value: "sku_publishday",
          label: "出版日期",
        },
        {
          value: "sku_isbn",
          label: "书号",
        },
        {
          value: "skuname",
          label: "书名",
        },
        {
          value: "SKU_author",
          label: "作者",
        },
      ],
      value: "",
    };
  },

  created() {},
  methods: {
    SelectCurrentValue(selVal) {
      this.searchcontent.sorderby = selVal;
    },
    advsearchop() {
      this.bshowmain = !this.bshowmain;
      this.bshowdetail = !this.bshowdetail;
    },
    // onselectchange(selVal) {
    //   this.dstart = "";
    //   this.dend = "";

    //   switch (selVal) {
    //     case "2":
    //       this.bshowdate = false;
    //       break;
    //     case "3":
    //       this.bshowdate = false;
    //       break;
    //     case "4":
    //       this.bshowdate = false;
    //       break;
    //     case "5":
    //       this.bshowdate = true;
    //       break;
    //     case "6":
    //       this.bshowdate = false;
    //       break;
    //     case "7":
    //       this.bshowdate = false;
    //       break;
    //     case "8":
    //       this.bshowdate = true;
    //       break;
    //     case "9":
    //       this.bshowdate = false;
    //       break;
    //     default:
    //       this.bshowdate = false;
    //   }
    // },

    searchdataout() {
      if (this.bshowdetail) {
        this.searchcontent.selectkind = "2";
      } else {
        this.searchcontent.selectkind = "1";
      }
      // this.searchcontent.sorderby = this.$refs.orderbyselect.options.label;
      // console.log("sorderby" + this.$refs.orderbyselect);
      this.$emit("opout", this.searchcontent);
    },
  },

  // props: ["searchdata"],
  // watch: {
  //   searchdata: function(val) {
  //     //在这里接收父组件参数
  //     this.searchfilter = decodeURIComponent(this.searchdata);
  //   },
  //   searchfilter: function(val) {
  //     //在哪里组合这个searchfilter？
  //     //在这里回调父组件方法，以返回参数
  //     var pdata = encodeURIComponent(this.searchfilter);
  //     this.$emit("getsearchdata", pdata);
  //   }
  // }
};
</script>

<style scoped>
.el-select {
  width: 100px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.el-input {
  font-size: 24px;
}
.mylable {
  text-align: center;
  margin-top: 15px;
}
</style>